import React from 'react';
import { Link } from 'gatsby';
import Layout from '../components/Layout';
import Helmet from 'react-helmet';

const NotFoundPage = () => (
  <Layout>
    <div>
      <Helmet>
        <title>404 - page not found - presono</title>
        <meta
          name="description"
          content="This page was not found and does not seem to exist."
        />
      </Helmet>
      <h1>NOT FOUND</h1>
      <p>This page doesnt exist</p>
      <Link to="/">Back to Start</Link>
    </div>
  </Layout>
)

export default NotFoundPage;
